// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./css/components/_custom-text.scss
// module id = 38
// module chunks = 0